import React, { createContext, useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useGetAllCoTeachersMutation } from '../../../../../features/authentication/classesApiSlice';

const ClassManagementContext = createContext();

const ClassManagementProvider = ({ children }) => {
  const [getCoTeachers] = useGetAllCoTeachersMutation();

  const [classes, setClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedCustomCourseId, setSelectedCustomCourseId] = useState(null);
  const [mathSkillCourses] = useState([26, 14, 101]);
  const [coTeachers, setCoTeachers] = useState(null);

  useEffect(() => {
    if (selectedClassId > 0)
      loadCoTeachers();
  }, [selectedClassId]);

  const loadCoTeachers = async () => {
    var response = await getCoTeachers(selectedClassId).unwrap(); 
    setCoTeachers(response);
  };

  return (
    <ClassManagementContext.Provider value={{ classes, setClasses, selectedClassId, setSelectedClassId, selectedCourseId, setSelectedCourseId, selectedCustomCourseId, setSelectedCustomCourseId, mathSkillCourses, coTeachers, setCoTeachers }}>
      {children}
    </ClassManagementContext.Provider>
  );
};

ClassManagementProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useClassManagementContext = () =>  useContext(ClassManagementContext);
export { ClassManagementProvider };
